import { useTranslation } from 'react-i18next'

import { MonthlyReservationsReport } from '../../../../../types/report/report'
import {
  createDateFormatter,
  createNumberFormatter,
} from '../../../../../utils/locale/localeUtils'

interface ReservationsChartProps {
  reports: MonthlyReservationsReport[]
  locale: string
}

export const ReservationsChart = ({
  reports,
  locale,
}: ReservationsChartProps) => {
  const { t } = useTranslation('reports')

  const numberFormatter = createNumberFormatter(locale)
  const totalReservations = (report: MonthlyReservationsReport) =>
    report.payPerPlayReservations + report.membershipReservations
  const maximumReservations = Math.max(...reports.map(totalReservations), 1)

  const monthFormatter = createDateFormatter(locale, {
    month: 'short',
    year: '2-digit',
    timeZone: 'UTC',
  })

  return (
    <div className="reservations-chart-content">
      <div className="reservations-chart-scroll-container">
        <div
          className={`reservations-chart${reports.length > 1 ? ' is-scrollable' : ''}`}
        >
          {reports.map(report => (
            <div key={report.month} className="reservations-chart-item">
              <div
                className="reservations-chart-column"
                style={{
                  height: `${(totalReservations(report) / maximumReservations) * 100}%`,
                }}
                title={t('reports.reservations.tooltip', {
                  value: numberFormatter.format(totalReservations(report)),
                })}
              >
                <div
                  className="reservations-chart-membership-segment"
                  style={{
                    height: `${
                      (report.membershipReservations / totalReservations(report)) *
                      100 || 0
                    }%`,
                  }}
                />
                <div
                  className="reservations-chart-pay-per-play-segment"
                  style={{
                    height: `${
                      (report.payPerPlayReservations /
                        totalReservations(report)) *
                        100 || 0
                    }%`,
                  }}
                />
              </div>
              <div className="reservations-chart-label">
                <div className="reservations-chart-value">
                  {numberFormatter.format(totalReservations(report))}
                </div>
                {monthFormatter.format(new Date(report.month))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
